import React, { useContext } from 'react'
import classNames from 'classnames'
import { NavLink } from 'react-router-dom'
import { Grid, GridItem } from '@deal/components'
import { useNavigationContext } from '#src/components/Header/StandardHeader/NavigationContext'
import MenuHeader from '../MenuHeader'
import styles from './styles.css'
import { useExperiment } from '@deal/experiment-js'
import ReleaseConsumerIdentityLink from '#src/components/Header/common/ReleaseConsumerIdentityLink'
import { IdentityContext } from '#src/containers/Identity'

interface AccountMenuProps {
  onNavItemSelected: () => void
}

const AccountMenu: React.FC<AccountMenuProps> = ({ onNavItemSelected }) => {
  const navContext = useNavigationContext()
  const { myself } = useContext(IdentityContext)
  const isImpersonating = myself && myself.user.id !== myself.realUser.id

  const { result: consumerGiftCardResult } = useExperiment({
    experiment: 'consumer-gift-card',
    defaultTreatment: 'off'
  })

  return (
    <div
      className={classNames(styles.menu, {
        [styles.visible]: !!navContext?.isMobileAccountMenuVisible
      })}
    >
      <Grid>
        <GridItem col={2}>
          <MenuHeader
            onBack={() => {
              navContext?.onToggleIsMobileAccountMenuVisible(false)
            }}
            header="Account"
          />
          <ul className={styles.list}>
            <NavLink to="/account/personal-information" onClick={() => onNavItemSelected()}>
              <li className={styles.listItem}>
                <span className={styles.listItemContents}>
                  <span className={styles.listItemLabel}>My account</span>
                </span>
              </li>
            </NavLink>
            <NavLink to="/account/notification-settings" onClick={() => onNavItemSelected()}>
              <li className={styles.listItem}>
                <span className={styles.listItemContents}>
                  <span className={styles.listItemLabel}>Notification settings</span>
                </span>
              </li>
            </NavLink>
            <NavLink to="/account/orders" onClick={() => onNavItemSelected()}>
              <li className={styles.listItem}>
                <span className={styles.listItemContents}>
                  <span className={styles.listItemLabel}>My orders</span>
                </span>
              </li>
            </NavLink>
            {consumerGiftCardResult === 'on' && (
              <NavLink to="/account/gift-cards" onClick={() => onNavItemSelected()}>
                <li className={styles.listItem}>
                  <span className={styles.listItemContents}>
                    <span className={styles.listItemLabel}>Gift cards</span>
                  </span>
                </li>
              </NavLink>
            )}

            {isImpersonating && (
              <ReleaseConsumerIdentityLink>
                <li className={styles.listItem}>
                  <span className={styles.listItemContents}>
                    <span className={styles.listItemLabel}>
                      Back to "{myself?.realUser.firstName}"
                    </span>
                  </span>
                </li>
              </ReleaseConsumerIdentityLink>
            )}

            <NavLink to="/auth/logout" rel="nofollow" onClick={() => onNavItemSelected()}>
              <li className={classNames(styles.listItem, styles.lastItem)}>
                <span className={styles.listItemContents}>
                  <span className={styles.listItemLabel}>Sign out</span>
                </span>
              </li>
            </NavLink>
          </ul>
        </GridItem>
      </Grid>
    </div>
  )
}

export default AccountMenu
